import React from "react";
import { StatusBadge } from "../../ui";

/**
 * UserRow — Reusable single row in users tables across SuperAdmin.
 */
const UserRow = ({ user, onClick, showInstitute = true }) => (
  <tr
    className={onClick ? "sa-mini-table__row--clickable" : ""}
    onClick={() => onClick?.(user)}
  >
    <td>
      <div className="d-flex align-items-center gap-2">
        <div className="sa-inst-avatar" style={{ width: 28, height: 28, fontSize: "0.6875rem" }}>
          {user.name?.[0]?.toUpperCase() || "?"}
        </div>
        <div>
          <div className="fw-medium" style={{ fontSize: "0.8125rem" }}>{user.name}</div>
          <div className="text-muted" style={{ fontSize: "0.6875rem" }}>{user.email || user.mobile || "—"}</div>
        </div>
      </div>
    </td>
    <td className="text-capitalize" style={{ fontSize: "0.8125rem" }}>{user.usertype || user.role || "—"}</td>
    {showInstitute && (
      <td style={{ fontSize: "0.8125rem" }}>{user.instituteName || "—"}</td>
    )}
    <td>
      <StatusBadge status={user.status === "active" ? "active" : "inactive"}>
        {user.status || "Active"}
      </StatusBadge>
    </td>
    <td style={{ fontSize: "0.8125rem" }}>
      {user.lastLogin ? new Date(user.lastLogin).toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" }) : "Never"}
    </td>
  </tr>
);

export default UserRow;
